import { Image, Tooltip, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const AvgTimeText = styled.p`
  align-items: center;
  display: flex;
  font-weight: 700;
  gap: 12px;
`;

const BarArea = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  gap: 12px;
`;

const Card = styled.div`
  background-color: var(--color-bg-weak);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex: 1;
  margin-bottom: var(--size-16);
  padding: var(--size-padding-16);
`;

const CardFooter = styled.div`
  padding: 0 4px;
  .average-detail-item.item-body .item-content {
    flex: 1;
  }
`;

const CardHeader = styled.div`
  margin-bottom: 8px;
`;

const GiftItem = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  position: relative;

  ${Image.S.Image} {
    border-radius: var(--size-border-radius-md);
    height: 42px;
    width: 42px;
  }
`;

const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 90px;
`;

const ScrollArea = styled.div`
  flex: 1 1 auto;
  max-height: 410px;
  min-height: 100%;
  overflow-y: auto;
`;

const Title = styled.div`
  align-items: center;
  color: var(--color-neutral-800);
  display: flex;
  flex-direction: row;
  font-size: 18px;
  font-weight: 700;
`;

const GiftSelection = styled.div`
  border: 1px solid var(--color-neutral-50);
  border-radius: var(--size-border-radius-md);
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: var(--size-padding-16);
`;

const EmptySectionWrapper = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
`;

const EmptyArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const SubTitle = styled(Typography)`
  text-align: center;
  width: 250px;
`;

const IconWrapper = styled.div`
  align-items: center;
  background-color: var(--color-bg-body);
  border: 2px solid var(--color-bg-weaker);
  border-radius: var(--size-border-radius-circle);
  bottom: -48px;
  display: flex;
  height: 16px;
  justify-content: center;
  position: absolute;
  right: -4px;
  width: 16px;
`;

const ImageWrapper = styled.div`
  height: fit-content;
  position: relative;

  ${Tooltip.S.Tooltip} {
    position: fixed !important;
  }
`;

const AvgWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export {
  AvgTimeText,
  AvgWrapper,
  BarArea,
  Card,
  CardFooter,
  CardHeader,
  EmptyArea,
  EmptySectionWrapper,
  GiftItem,
  GiftSelection,
  IconWrapper,
  ImageWrapper,
  Rate,
  ScrollArea,
  SubTitle,
  Title
};
